import { createStyles, rem } from '@mantine/core'

import { MultipleBanner } from '../../index.types'

type StyleParams = {
  layout: MultipleBanner['layout']
  infoLayout: 'horizon' | 'vertical'
  ratio: number
  fixSizeBanner: boolean
  radius: number
}

export default createStyles(
  (
    theme,
    { layout, infoLayout, ratio, fixSizeBanner, radius }: StyleParams,
  ) => {
    const bannerWithBtn = layout === 'image_overlay_button'
    const bannerWithFullInfo = layout === 'image_on_top_button_below'
    const infoHorizonLayout = infoLayout === 'horizon'
    const infoVerticalLayout = infoLayout === 'vertical'
    const bannerWithBtnMobileRatio = 448 / 320
    const bannerWithFullInfoMobileRatio = 249 / 320

    return {
      root: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        borderRadius: 16,
        backgroundColor: '#fff',
        [theme.fn.largerThan('sm')]: {
          boxShadow:
            '0px 0px 1px 0px #0000000A, 0px 2px 8px 0px #0000000A, 0px 16px 24px 0px #0000000F',
          borderRadius: radius,
          ...(!fixSizeBanner && {
            height: '100%',
          }),
        },
      },

      // ----- Info -----
      info: {
        gap: 16,
        ...(bannerWithBtn && {
          position: 'absolute',
          insetInline: 0,
          bottom: 0,
          paddingBottom: 40,
          display: 'flex',
          justifyContent: 'center',
        }),
        ...(bannerWithFullInfo && {
          borderRadius: 16,
          height: '100%',
          borderTopLeftRadius: '0',
          borderTopRightRadius: '0',
          padding: rem(12),
        }),
        ...(infoVerticalLayout && {
          justifyContent: 'space-between',
        }),
        [theme.fn.smallerThan('sm')]: {
          paddingBottom: 16,
        },
        [theme.fn.largerThan('sm')]: {
          ...(bannerWithFullInfo && {
            alignItems: infoHorizonLayout ? 'center' : 'stretch',
            padding: `${rem(12)} ${rem(16)}`,
          }),
          ...(infoHorizonLayout && {
            flexDirection: 'row',
            gap: rem(4),
          }),
        },
      },

      // ----- Picture -----
      picture: {
        ...(!fixSizeBanner && {
          display: 'block',
          height: 0,
          paddingBottom: `${ratio * 100}%`,
          position: 'relative',
          [theme.fn.smallerThan('sm')]: {
            paddingBottom: `${
              (bannerWithBtn
                ? bannerWithBtnMobileRatio
                : bannerWithFullInfoMobileRatio) * 100
            }%`,
          },
        }),
        img: {
          borderRadius: 16,
          ...(bannerWithFullInfo && {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          }),
          ...(!fixSizeBanner && {
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }),
          [theme.fn.largerThan('sm')]: {
            borderRadius: radius,
            ...(bannerWithFullInfo && {
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
            }),
          },
        },
      },

      // ----- Header -----
      header: {
        gap: 4,
      },

      // ----- Actions -----
      actions: {
        ...(bannerWithBtn && {
          paddingLeft: 16,
          paddingRight: 16,
          textAlign: 'center',
        }),
      },

      // ----- Button -----
      btn: {
        minWidth: rem(168),
        [theme.fn.smallerThan('sm')]: {
          width: '100%',
        },
        [theme.fn.largerThan('sm')]: {
          ...(bannerWithFullInfo && {
            width: '100%',
          }),
        },
      },
    }
  },
)
